$('.blog-grid').masonry({
    "itemSelector" : ".grid-item",
    "columnWidth" : ".grid-sizer",
    "gutter" : 10
});